import Splide from '@splidejs/splide';

export default function slidersHandler() {

	const initLegendSlider = () => {
		const legendSlider = document.querySelector('.-js-legend-slider');

		if (legendSlider) {
			const slider = new Splide(legendSlider, {
				autoWidth: false,
				autoWidth: true,
				type: 'loop',
				pagination: false,
				snap: true,
				mediaQuery: 'min',
				arrows: false,
				autoplay: false,
				speed: 1500,
				gap: '3.5625rem',
		
			}).mount();

			const btnNext = legendSlider.querySelector('.splide__button--next');

			btnNext.addEventListener('click', (e) => {
				slider.go('+1');
			});
		}
	}

	const initHomeHeroSlider = () => {
		const heroSlider = document.querySelector('.js-hero-slider');

		if (heroSlider) {
			const slider = new Splide(heroSlider, {
				focus: 'center',
				autoWidth: false,
				perPage: 1,
				type: 'fade',
				rewind: true,
				perMove: 1,
				pagination: true,
				arrows: false,
				autoplay: true,
				interval: 5000,
				speed: 1500,
				reducedMotion: {
					interval: 5000,
					speed: 1500,
					autoplay: 'play',
				},
			}).mount();

			const btnPrev = heroSlider.querySelector('.splide__button--prev');
			const btnNext = heroSlider.querySelector('.splide__button--next');

			btnNext.addEventListener('click', (e) => {
				slider.go('+1');
			});
		}
	};

	const initGallerySliders = () => {
		const gallerySliders = document.querySelectorAll('.js-gallery-slider');

		gallerySliders.forEach(gallerySlider => {
			const slider = new Splide(gallerySlider, {
				focus: 'center',
				autoWidth: true,
				type: 'loop',
				perMove: 1,
				pagination: false,
				arrows: false,
				gap: '4px',
				reducedMotion: {
					speed: 1500,
				},
			}).mount();

			const btnNext = gallerySlider.querySelector('.splide__button--next');
			const btnPrev = gallerySlider.querySelector('.splide__button--prev');

			btnNext.addEventListener('click', (e) => {
				slider.go('+1');
			});

			btnPrev.addEventListener('click', (e) => {
				slider.go('-1');
			});
		});
	};

	const initHouseGalleries = () => {
		const houseSliders = document.querySelectorAll('.js-house-gallery-slider');

		houseSliders.forEach(houseGallery => {
			const slider = new Splide(houseGallery, {
				focus: 'left',
				autoWidth: true,
				type: 'loop',
				perMove: 1,
				pagination: false,
				arrows: false,
				gap: '10px',
				reducedMotion: {
					speed: 1500,
				},
			}).mount();

			const btnNext = houseGallery.querySelector('.splide__button--next');
			// const btnPrev = gallerySlider.querySelector('.splide__button--prev');

			btnNext.addEventListener('click', (e) => {
				slider.go('+1');
			});

			// btnPrev.addEventListener('click', (e) => {
			// 	slider.go('-1');
			// });
		});
	};

	initHomeHeroSlider();
	initGallerySliders();
	initHouseGalleries();
	initLegendSlider();
}
